<div class="maintenance-status-section">
  <div class="maintenance-status-header">
    <h3 class="desktop-dashboard-title">{{ 'maintenanceStatus' | translate }}</h3>
    <div class="maintenance-status-copy mobile-dashboard-copy">
      <h3>{{ 'maintenanceJobs' | translate }}</h3>
      <p>{{ 'dashboardMaintenanceDescription' | translate }}</p>
    </div>
    <div class="maintenance-status-actions">
      <app-ui-select
        class="vessel-select"
        [label]="'departmentSelector' | translate"
        [control]="vesselControl"
        [options]="vesselOptions()"
        [isMultiple]="false"
        [enableSearch]="true"
        [compactOnMobile]="true"
        triggerPrefix="department"
        panelClass="dashboard-department-select-panel"
      ></app-ui-select>
      <app-dashboard-time-period-select
        class="desktop-dashboard-period-select"
        [periodControl]="periodControl"
        [customRangeControl]="customRangeControl"
      ></app-dashboard-time-period-select>
    </div>
  </div>
  <div
    class="maintenance-widgets-row"
    *appLoader="(loadingActions | actionInProgress: true | async) === true"
  >
    <!-- Expired jobs + Critical (dual) -->
    <app-ui-widget-card
      [blocks]="expiredJobsData"
      statusName="expired"
      statusIcon="error_outline"
      statusColor="red"
      [blockLabels]="['all', 'critical']"
      [statusOnMobile]="true"
      [clickable]="true"
      (blockClick)="onExpiredJobsBlockClick($event)"
    ></app-ui-widget-card>

    <!-- Due soon jobs + Critical (dual) -->
    <app-ui-widget-card
      [blocks]="dueSoonJobsData"
      statusName="dueSoon"
      statusIcon="warning_amber"
      statusColor="yellow"
      [blockLabels]="['all', 'critical']"
      [statusOnMobile]="true"
      [clickable]="true"
      (blockClick)="onDueSoonJobsBlockClick($event)"
    ></app-ui-widget-card>

    <!-- Postponed jobs (single) -->
    <app-ui-widget-card
      name="postponedJobs"
      statusName="postponed"
      statusIcon="schedule"
      statusColor="orange"
      [statusOnMobile]="true"
      [value]="postponedJobs"
      icon="schedule"
      iconColor="orange"
      [clickable]="false"
      [matTooltip]="'postponedJobsTooltip' | translate"
    ></app-ui-widget-card>

    <!-- In progress jobs (single) -->
    <app-ui-widget-card
      name="inProgressJobs"
      statusName="inProgress"
      statusIcon="sync"
      statusColor="cyan"
      [statusOnMobile]="true"
      [value]="inProgressJobs"
      icon="sync"
      iconColor="cyan"
      [clickable]="true"
      [matTooltip]="'inProgressJobsTooltip' | translate"
      matTooltipMobileTap="off"
      (click)="openInProgressJobs()"
    ></app-ui-widget-card>

    <div class="completed-widget-row">
      <app-ui-widget-card
        name="completedJobs"
        statusName="completed"
        statusIcon="check"
        statusColor="green"
        [statusOnMobile]="true"
        [value]="completedJobs"
        description="forTimePeriod"
        icon="check"
        iconColor="green"
        [clickable]="false"
        [matTooltip]="'completedJobsTooltip' | translate"
      ></app-ui-widget-card>
      <app-dashboard-time-period-select
        [periodControl]="periodControl"
        [customRangeControl]="customRangeControl"
      ></app-dashboard-time-period-select>
    </div>
  </div>
</div>
